import script from "./MainAutoMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainAutoMessage.vue?vue&type=script&setup=true&lang=js"

import "./MainAutoMessage.vue?vue&type=style&index=0&id=2cc14169&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc14169"]])

export default __exports__